import { Avatar, Box, Button, Card, CardContent, CardHeader, Container, IconButton, Typography } from "@mui/material";
import { AtendimentoViewProps, mapDispatchToAtendimentoProps, mapStateToAtendimentoProps } from "../atendimento.controller";
import { connect } from "react-redux";
import { Campaign, HowToReg, Logout } from "@mui/icons-material";
import { handleReadPacientesByAtendimento, PacienteAtendimentoListView } from "../../paciente/view/paciente.select";
import { Paciente } from "../../paciente/paciente.model";
import { useEffect, useState } from "react";
import { formatTime, isEmpty } from "../../../services/utils";
import { ToolbarCad } from "../../../components/toolbar";
import { ChipWithProgress } from "../../../components/ChipProgress";
import Modal from "../../../components/modal";
import { PathRotaAtendimento } from "../atendimento.router";
import { rotas } from "../../../services/router";

function Atendimento(props: AtendimentoViewProps) {
    const { atendimentoState, atendimentoActions } = props
    const { row, pacienteChamado, showModalChamarPaciente } = atendimentoState
    const { setShowModalChamarPaciente, getPacienteChamando,fecharSessaoAtendimento } = atendimentoActions

    useEffect(() => {
        handleReadPacientesByAtendimento(row)
    }, [])

    useEffect(()=>{
        if(!row._id){
            rotas.navigate(PathRotaAtendimento.abrirAtendimento)
        }
    },[row._id])

    const ViewChamarPaciente = () => {
        const Chamando = () => {
            const [progress, setProgress] = useState(0);
            var timer: any;

            useEffect(() => {
                timer = setInterval(() => {
                    setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 5));
                }, 1200);
                if(!pacienteChamado.chamando){
                    clearInterval(timer);
                }
                return () => {
                    clearInterval(timer);
                };
            }, []);

            if (progress === 100) {
                getPacienteChamando(pacienteChamado)
            }

            return (
                <ChipWithProgress label="Chamando" progress={progress} />
            )
        }
        if (isEmpty(pacienteChamado))
            return <div></div>
        return (
            <Box>
                <ToolbarCad
                    title="Chamar Paciente"
                    variantToobar="dense"
                    buttonNovo={{ show: false, onClick: () => { }, title: "" }}
                    elevation={2}
                />
                <Container sx={{ mt: 2, mb: 2 }}>
                    <Typography variant="h4">Paciente       : {pacienteChamado.nome}</Typography>
                    <Typography variant="h4">Horario Chamado: {formatTime(pacienteChamado.dt_hr_chamada)}</Typography>
                    <Box sx={{ display: "flex", flex: 1, justifyContent: "space-between" }}>
                        <Button
                            variant="contained"
                            size="large"
                            color="error"
                            endIcon={<HowToReg />}
                            onClick={() => {
                                setShowModalChamarPaciente({
                                    chamar: false,
                                    finaliza: true,
                                    setModal: false,
                                    paciente: pacienteChamado
                                });
                                handleReadPacientesByAtendimento(row)
                            }}
                        >
                            Finalizar Atendimento
                        </Button>
                        {pacienteChamado.chamando ? (
                            <Chamando />
                        ) : (
                            <Button
                                variant="contained"
                                size="large"
                                color="success"
                                endIcon={<Campaign />}
                                onClick={() => {
                                    setShowModalChamarPaciente({
                                        chamar: true,
                                        finaliza: false,
                                        paciente: pacienteChamado,
                                        setModal: true
                                    })
                                }}
                            >
                                Chamar Novamente
                            </Button>
                        )}

                    </Box>

                </Container>
            </Box>
        )
    }
    return (
        <Box sx={{ display: "flex", flex: 1, flexDirection: "column", mt: 2 }}>
            <Card>
                <CardHeader

                    avatar={
                        <Avatar>{row.medico.nome[0]}</Avatar>
                    }
                    title={row.medico.nome}
                    subheader={row.sala_atendimento?.descricao}
                    action={
                        <IconButton
                            title="Encerrar sessão de atendimento"
                            onClick={()=>{
                                fecharSessaoAtendimento()
                            }}
                        >
                            <Logout />
                        </IconButton>
                    }
                />
                <CardContent sx={{ mt: 2, display: "flex", flex: 1 }}>
                    <PacienteAtendimentoListView
                        atendimento={row}
                        handleRowClick={(row) => setShowModalChamarPaciente({
                            chamar: true,
                            finaliza: false,
                            paciente: row,
                            setModal: true
                        })}
                    />

                </CardContent>
            </Card>
            <Modal
                component={<ViewChamarPaciente />}
                handleClose={() => { }}
                heigth="auto"
                open={showModalChamarPaciente}
                width="sm"
                handleOnKeyDown={() => { }}
            />

        </Box>
    )
}

export default connect(mapStateToAtendimentoProps, mapDispatchToAtendimentoProps)(Atendimento)